export const getRecNumString = (recNum) => {
  if (parseInt(recNum, 10) >= 100000) {
    return '10K+';
  }
  return String(recNum);
};

export const getImage = () => {

};
